/** Quote price helpers (base fuel price + per-gallon margin). */

export function parseQuoteMargin(value) {
  const n = parseFloat(value);
  return Number.isFinite(n) && n >= 0 ? n : 0;
}

export function effectiveQuotePricePerGallon(basePrice, margin) {
  return (parseFloat(basePrice) || 0) + parseQuoteMargin(margin);
}

/** Estimate quote total from current pricing row and quote form values (matches backend logic). */
export function calculateQuoteEstimate(pricing, quoteValues = {}) {
  if (!pricing) return 0;

  const dieselQty = parseFloat(quoteValues.diesel_quantity) || 0;
  const defQty = parseFloat(quoteValues.def_quantity) || 0;
  const dyedQty = parseFloat(quoteValues.dyed_quantity) || 0;
  const deliveryFee = parseFloat(quoteValues.delivery_fee) || 0;

  const dieselPrice = effectiveQuotePricePerGallon(
    pricing.diesel_price_per_liter,
    quoteValues.diesel_margin
  );
  const defPrice = effectiveQuotePricePerGallon(pricing.def_price_per_liter, quoteValues.def_margin);
  const dyedPrice = effectiveQuotePricePerGallon(
    pricing.dyed_price_per_liter,
    quoteValues.dyed_margin
  );

  const dieselTax = parseFloat(pricing.diesel_sales_tax) || 0;
  const defTax = parseFloat(pricing.def_sales_tax) || 0;
  const dyedTax = parseFloat(pricing.dyed_sales_tax) || 0;

  const dieselCost = dieselQty * dieselPrice;
  const defCost = defQty * defPrice;
  const dyedCost = dyedQty * dyedPrice;

  const dieselTaxAmount = dieselCost * dieselTax;
  const defTaxAmount = defCost * defTax;
  const dyedTaxAmount = dyedCost * dyedTax;

  return (
    dieselCost +
    dieselTaxAmount +
    defCost +
    defTaxAmount +
    dyedCost +
    dyedTaxAmount +
    deliveryFee
  );
}

/** Pricing row with quote margins applied (for display during quote creation). */
export function applyQuoteMarginsToPricing(pricing, quoteValues = {}) {
  if (!pricing) return null;
  const diesel = effectiveQuotePricePerGallon(pricing.diesel_price_per_liter, quoteValues.diesel_margin);
  const defPrice = effectiveQuotePricePerGallon(pricing.def_price_per_liter, quoteValues.def_margin);
  const dyed = effectiveQuotePricePerGallon(pricing.dyed_price_per_liter, quoteValues.dyed_margin);
  return {
    ...pricing,
    diesel_price_per_liter: diesel,
    def_price_per_liter: defPrice,
    dyed_price_per_liter: dyed,
    diesel_price_per_gallon: diesel,
    def_price_per_gallon: defPrice,
    dyed_price_per_gallon: dyed,
  };
}
